import { Link } from "@mui/material";
import { TbShirtSport } from "react-icons/tb";
import { HiOutlineTicket } from "react-icons/hi";
import { MdOutlineEventSeat, MdOutlinedFlag } from "react-icons/md";

export const FresnoGrizzliesLink = () => (
  <Link
    target="_blank"
    href="https://mlb.tickets.com/ticketmanagement/?agency=FRGM_MYTIXX&orgid=57457#/"
    sx={{
      fontWeight: 500,
      color: "primary.main",
      textDecoration: "none",
    }}
  >
    MyProVenue
  </Link>
);

export const howItWorks = [
  {
    icon: <MdOutlinedFlag />,
    title: "Choose Your Games",
    description: "Select the games you wish to attend.",
  },
  {
    icon: <MdOutlineEventSeat />,
    title: "Login to MiLB.com",
    description:
      "Click Continue and connect your Fresno Grizzlies account using our secure MLB.com login.",
  },
  {
    icon: <TbShirtSport />,
    title: "Select Your Seats",
    description: "Select the seats you wish to purchase for each game.",
  },
  {
    icon: <HiOutlineTicket />,
    title: "Get Your Tickets",
    description: (
      <>
        Tickets will be available in your <FresnoGrizzliesLink /> 24 hours of
        purchase. Reach out to Live Fan Support for any questions.
      </>
    ),
  },
];

export const faqs = [
  {
    title: "How does the Fresno Grizzlies Mini Plan Program work?",
    description:
      "The Fresno Grizzlies Mini Plan Program allows fans to select any seat to select games hosted by the Fresno Grizzlies. Simply log into your MLB.com and select games.",
  },
  {
    title: "Do I have to select all my games now?",
    description: "Yes, you must select all games at the time of purchase.",
  },
  {
    title: "Can I choose seats throughout the venue?",
    description: "Yes, you can choose from all current available inventory.",
  },
  {
    title: "Where are event tickets delivered?",
    description: (
      <>
        Tickets are delivered directly within your Fresno Grizzlies{" "}
        <FresnoGrizzliesLink /> Account.
      </>
    ),
  },
];
